import { Link } from 'react-router-dom';
import { topics } from '@/mocks/topics';
import { contactInfo } from '@/mocks/site';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-radar-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">黑料雷达</span>
            </div>
            <p className="mt-4 text-sm leading-6 text-background-200/90">
              {contactInfo.tagline}。我们整理数据泄露、安全漏洞、盗刷事件、违规收集与监管处罚记录，
              帮助你在注册、授权与支付之前，先看清平台的安全水位。
            </p>
          </div>

          <nav aria-label="内容导航">
            <h2 className="font-heading text-sm font-bold text-background-50">内容导航</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200/90">
              <li><Link to="/" className="transition-colors hover:text-background-50">首页</Link></li>
              <li><Link to="/incidents" className="transition-colors hover:text-background-50">事件库</Link></li>
              <li><Link to="/topics" className="transition-colors hover:text-background-50">风险分类</Link></li>
              <li><Link to="/about" className="transition-colors hover:text-background-50">关于我们</Link></li>
              <li><Link to="/contact" className="transition-colors hover:text-background-50">报料与联系</Link></li>
            </ul>
          </nav>

          <nav aria-label="风险分类导航">
            <h2 className="font-heading text-sm font-bold text-background-50">风险分类</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200/90">
              {topics.slice(0, 5).map((topic) => (
                <li key={topic.slug}>
                  <Link
                    to={`/topic/${topic.slug}`}
                    className="transition-colors hover:text-background-50"
                  >
                    {topic.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h2 className="font-heading text-sm font-bold text-background-50">联系我们</h2>
            <ul className="mt-4 space-y-3 text-sm text-background-200/90">
              <li className="flex items-start gap-2">
                <span className="mt-0.5 flex h-4 w-4 items-center justify-center">
                  <i className="ri-mail-send-line text-sm"></i>
                </span>
                <span>
                  线索报料：{contactInfo.email}
                  <br />
                  商务合作：{contactInfo.cooperativeEmail}
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-0.5 flex h-4 w-4 items-center justify-center">
                  <i className="ri-time-line text-sm"></i>
                </span>
                <span>{contactInfo.workingHours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-50/15 pt-6">
          <p className="text-xs leading-6 text-background-300/80">
            免责声明：本站内容基于公开信息整理，仅用于风险提示与安全意识科普，不构成任何法律意见或对特定主体的最终定性。
            如相关方持有可推翻原始结论的正式说明与证据，欢迎通过上方邮箱联系我们，我们将在核实后更正并保留更新记录。
          </p>
          <div className="mt-5 flex flex-col gap-2 text-xs text-background-300/80 sm:flex-row sm:items-center sm:justify-between">
            <p>© {year} 黑料雷达 · 保留所有权利</p>
            <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
              <Link to="/about" className="transition-colors hover:text-background-50">内容原则</Link>
              <Link to="/contact" className="transition-colors hover:text-background-50">报料须知</Link>
              <span>本站不提供删稿付费服务</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}